import styled from 'styled-components'

import { Notes, textInputStyles, textInputStylesConfig } from '../../../_constants/styles'
import { S_LoaderButton } from '../../LoaderButton'

export const S_NoteEditor = styled.div`
  display: flex;
  justify-content: flex-start;

  flex-direction: ${(props) => props.flexType ?? 'row'};
  justify-content: ${(props) => (props.flexType === 'row' ? 'space-between ' : '')};

  &.timeline {
    justify-content: flex-end;
    width: calc(100% - 110px);
    padding-left: 30px;
    margin-left: auto;
    .note-editor-field {
      max-width: 100%;
      width: 100%;
      margin-bottom: 10px;
    }
    .note-editor-btn {
      margin-left: auto;
    }
  }

  h3 {
    ${Notes.headerStyles}
  }

  .note-editor-field {
    margin-bottom: 15px;
    &.limited-width {
      ${textInputStyles}
      width: 240px;
      max-width: 240px; /* prevent text-area overflow*/
      min-width: 240px;
      min-height: ${textInputStylesConfig.minHeight};
    }

    &.full-width {
      ${Notes.noteStyles}
      font-family: 'Lato';
      max-width: 100%;
      resize: none;
      margin-bottom: 18px;
      min-height: calc(${Notes.height} + ${Notes.margin});
      outline: none;
      padding-bottom: 16.5px;
      width: 100%;
    }
  }

  .error {
    color: tomato;
    height: 30px;
  }

  ${S_LoaderButton} {
    margin-left: auto;
  }
`
